<template>
<div class="chapter">
<div class="inner_page">
<div id="fm5">
<p class="dedi"><em class="italic">For my mother, whose beloved stories of a late Victorian childhood made those years very real for me.</em></p>
<p class="dedi"><em class="italic">And for Viola, Ernestine, and Becky, who made suggestions.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// For_my_mother.vue?d856ee56